/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetWithdrawalFeeQuoteOptions,
  GetWithdrawalFeeQuoteResponses,
} from '../types/GetWithdrawalFeeQuote'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Estimates the network fee for an existing, admin-approved (APPROVED_WITHOUT_FEE) withdrawal owned by the caller. Redeem the returned quote token at PUT /v1/web3/withdrawals/{withdrawal_id} to reserve the fee. Restricted to USDC native-asset users.
 * @summary Estimate the network fee to withdraw USDC via web3
 * {@link /v1/web3/withdrawals/fee-quote}
 */
export function getWithdrawalFeeQuote<ThrowOnError extends boolean = true>(
  options: Options<GetWithdrawalFeeQuoteOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetWithdrawalFeeQuoteResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/web3/withdrawals/fee-quote',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetWithdrawalFeeQuoteResponses, ThrowOnError>>,
  )
}
